import { render, staticRenderFns } from "./create-static-document.vue?vue&type=template&id=8572a93e&"
import script from "./create-static-document.vue?vue&type=script&lang=js&"
export * from "./create-static-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports